import React from 'react';
import PropTypes from 'prop-types';

import BookButton from 'components/bookButton/BookButton';
import { Tooltip } from 'components/common/tooltip';

import './RoomBookButtons.css';

const RoomBookButtons = ({
    currencySymbol,
    isRoomAvailable,
    Lang,
    rate,
    onClick,
    isDirect,
    noRedirect = false,
    isLoading = false,
}) => {
    if (!rate) {
        return null;
    }

    const showTooltip =
        rate?.pricing?.memberPrice &&
        rate.availableRooms[0]?.memberBookNowText &&
        rate.availableRooms[0]?.memberBookNowUrl;

    return (
        <div>
            {isRoomAvailable ? (
                <>
                    {showTooltip ? (
                        <Tooltip
                            arrow
                            interactive
                            content={
                                <div className="ab-book-buttons-tooltip-content">
                                    <BookButton
                                        currencySymbol={currencySymbol}
                                        price={`${rate?.pricing?.price}`}
                                        text={
                                            noRedirect
                                                ? Lang?.select
                                                : rate.availableRooms[0]
                                                      ?.BookNowText
                                        }
                                        url={rate.availableRooms[0]?.bookNowUrl}
                                        variant="non-member"
                                        onClick={onClick}
                                        isDirect={isDirect === 1}
                                        noRedirect={noRedirect}
                                    />
                                    <BookButton
                                        currencySymbol={currencySymbol}
                                        price={`${rate?.pricing?.memberPrice}`}
                                        text={
                                            noRedirect
                                                ? Lang?.select
                                                : rate.availableRooms[0]
                                                      ?.memberBookNowText
                                        }
                                        url={
                                            rate.availableRooms[0]
                                                ?.memberBookNowUrl
                                        }
                                        variant="member"
                                        onClick={onClick}
                                        isDirect={isDirect === 1}
                                        noRedirect={noRedirect}
                                    />
                                    {rate?.pricing?.savePrice > 0 && (
                                        <p className="ab-join-us-discount-msg">
                                            {Lang.joinUsDiscountMsg}{' '}
                                            <span>
                                                {currencySymbol}
                                                {rate?.pricing?.savePrice}
                                            </span>
                                        </p>
                                    )}
                                </div>
                            }
                            zIndex={100004}
                            // trigger="click"
                        >
                            <BookButton
                                text={
                                    noRedirect
                                        ? Lang?.select
                                        : rate.availableRooms[0]?.BookNowText
                                }
                                url={
                                    rate?.pricing?.memberPrice > 0
                                        ? rate.availableRooms[0]
                                              ?.memberBookNowUrl
                                        : rate.availableRooms[0]?.bookNowUrl
                                }
                                price={`${
                                    rate?.pricing?.memberPrice > 0
                                        ? rate?.pricing?.memberPrice
                                        : rate?.pricing?.price
                                }`}
                                currencySymbol={currencySymbol}
                                onClick={onClick}
                                isDirect={isDirect === 1}
                                noRedirect={noRedirect}
                                isLoading={isLoading}
                            />
                        </Tooltip>
                    ) : (
                        <BookButton
                            text={
                                noRedirect
                                    ? Lang?.select
                                    : rate.availableRooms[0]?.BookNowText
                            }
                            url={rate.availableRooms[0]?.bookNowUrl}
                            price={`${
                                rate?.pricing?.memberPrice > 0
                                    ? rate?.pricing?.memberPrice
                                    : rate?.pricing?.price
                            }`}
                            currencySymbol={currencySymbol}
                            onClick={onClick}
                            isDirect={isDirect === 1}
                            noRedirect={noRedirect}
                            isLoading={isLoading}
                        />
                    )}
                </>
            ) : (
                <BookButton
                    text={noRedirect ? Lang?.select : rate?.memberBookNowText}
                    url=""
                />
            )}
        </div>
    );
};

RoomBookButtons.propTypes = {
    currencySymbol: PropTypes.string.isRequired,
    isRoomAvailable: PropTypes.bool.isRequired,
    Lang: PropTypes.object.isRequired,
    rate: PropTypes.object.isRequired,
    onClick: PropTypes.func,
    isDirect: PropTypes.number,
    noRedirect: PropTypes.bool,
    isLoading: PropTypes.bool,
};

export default RoomBookButtons;
